@if (activeAddress(); as activeAddress) {
  <div class="delivery-active-address">
    <div class="delivery-active-address-info">
      <div class="text-c1-l-500">{{ activeAddress.formattedAddress }} , {{ activeAddress.appartment }}</div>
      <div class="delivery-active-address-details text-c1-l-300">
        @if (activeAddress.entrance) {
          <span>подъезд: {{ activeAddress.entrance }}</span>
        }

        @if (activeAddress.floor) {
          <span>этаж: {{ activeAddress.floor }}</span>
        }

        @if (activeAddress.domofon) {
          <span>домофон: {{ activeAddress.domofon }}</span>
        }
      </div>
    </div>
    <button
      sdButton
      class="delivery-active-address-button text-b3-s-300 text-lg-c2-l-500 color-black"
      theme="secondary"
      (click)="openModal()"
    >
      @if (!isDesktopLgUp()) {
        <sd-icon class="icon-size-s icon-size-md-m" [type]="iconTypes.MAP_LOCATION"></sd-icon>
      }

      {{ changeButtonText() }}
    </button>
  </div>
}
